module.exports = __webpack_public_path__ + "img/express-1.417b922a.png";